import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path ? 'text-primary-600 font-medium' : 'text-gray-700 hover:text-primary-600 transition-colors';
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-28">
          <Link to="/" className="flex items-center h-full py-4">
            <img 
              src="/24lp-logo-primary.png"
              alt="Twenty Four Capital" 
              className="h-20 md:h-24 w-auto object-contain block"
            />
            {/* Fallback text - hidden by default */}
            <span className="hidden text-2xl font-bold text-primary-900 ml-2">
              Twenty Four Capital
            </span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className={isActive('/')}>Home</Link>
            <Link to="/blog" className={isActive('/blog')}>Blog</Link>
            <Link to="/glossary" className={isActive('/glossary')}>Glossary</Link>
            <Link to="/faq" className={isActive('/faq')}>FAQ</Link>
            <Link to="/broker/register" className="text-primary-600 hover:text-primary-700 font-medium transition-colors">
              Partner Signup
            </Link>
            <Link to="/login" className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition-colors">
              Login
            </Link>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden">
            <button className="text-gray-700 hover:text-primary-600">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation; 